export const LoaderStyle = {
  color: '#fff',
  zIndex: 100000
};